import { Component, OnInit, forwardRef } from '@angular/core';
import { NavController, NavParams, ModalController, IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ContribuicoesDetalhesPage } from '../contribua/contribuicoes-detalhes/contribuicoes-detalhes.page';
import { UserProvider } from 'src/app/services/user/user';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-minhas-contribuicoes',
  templateUrl: './minhas-contribuicoes.page.html',
  styleUrls: ['./minhas-contribuicoes.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule
  ],
})
export class MinhasContribuicoesPage implements OnInit {
  contribuicoes: any = [];
  idPessoa: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public translate: TranslateService,
    public userProvider: UserProvider,
    public modalCtrl: ModalController,
  ) {
    this.idPessoa = this.navParams.get('idPessoa');
    this.userProvider.contribuicoes().subscribe((data) => {
      this.contribuicoes = data;
    });
  }

  ngOnInit() {
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  async detalhes(contribuicao: { idPlanoConta: any; }) {
    var data = { 'idPessoa': this.idPessoa, 'idPlanoContas': contribuicao.idPlanoConta };
    const modalPage = await this.modalCtrl.create({ component: ContribuicoesDetalhesPage, componentProps: data });
    modalPage.present();
  }

}
